import React from 'react'

const ReconciliationLegend: React.FC = () => (
    <div className="mt-4 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 px-4 py-3">
        <div className="flex items-center gap-6 text-xs text-slate-500 dark:text-slate-400 flex-wrap">
            <span className="flex items-center gap-1.5">
                <span className="w-3 h-3 rounded-full bg-green-100 dark:bg-green-900/30 ring-1 ring-green-600/20 dark:ring-green-400/20 inline-block" />
                Good
            </span>
            <span className="flex items-center gap-1.5">
                <span className="w-3 h-3 rounded-full bg-yellow-100 dark:bg-yellow-900/30 ring-1 ring-yellow-600/20 dark:ring-yellow-400/20 inline-block" />
                Warning
            </span>
            <span className="flex items-center gap-1.5">
                <span className="w-3 h-3 rounded-full bg-orange-100 dark:bg-orange-900/30 ring-1 ring-orange-600/20 dark:ring-orange-400/20 inline-block" />
                <span className="font-medium text-orange-700 dark:text-orange-400">&ne;</span> Mismatch between sources
            </span>
            <span className="flex items-center gap-1.5">
                <span className="w-3 h-3 rounded-full bg-red-100 dark:bg-red-900/30 ring-1 ring-red-600/20 dark:ring-red-400/20 inline-block" />
                Missing / Error
            </span>
            <span className="flex items-center gap-1.5">
                <span className="w-3 h-3 rounded-full bg-slate-100 dark:bg-slate-700/50 ring-1 ring-slate-300 dark:ring-slate-600 inline-block" />
                Source unavailable
            </span>
            <span className="ml-auto text-slate-400 dark:text-slate-500 italic">Hover any cell for its data source &amp; how to resolve issues</span>
        </div>
    </div>
)

export default ReconciliationLegend
